<template>
  <div class="app-container">
    <div class="news-banner">
      <!--<el-image :src="require('@/assets/yuanjing/news_banner.png')" fit="cover"/>-->
      <img src="../assets/news/news_banner.png" alt="">
    </div>
    <div class="news-area">
      <div class="news-search">
        <div>
          <div>卡泰驰新闻</div>
          <div class="base-line"></div>
        </div>
        <div>
          <el-input placeholder="关键字搜索" v-model="queryParams.newsTitle"
            class="input-with-select search-input" @keyup.enter.native="getList"
          >
            <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
          </el-input>
        </div>
      </div>
      <div class="news-list">
        <div v-for="(item, idx) in newsList" :key="idx" class="new-item" @click="skipToInfo(item)">
          <el-image :src="item.thumbnailUrl" class="new-item-img"/>
          <p class="new-item-title">{{item.newsTitle}}</p>
          <p class="new-item-date">{{item.createTime}}</p>
        </div>
      </div>

    </div>
    <!--// 页脚-->
    <div class="pagination">
      <!--只有一页时候隐藏分页  -->
      <!--hide-on-single-page-->

      <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryParams.pageNum"
      :page-sizes="[1,2,3,4,5,6,7,8,9]"
      :page-size="queryParams.pageSize"
      layout="sizes, prev, pager, next, jumper"
      :total="total"
    >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import TinymceEditor from '../../components/tinymce-editor/index'
export default {
  name: 'NewsInfo',
  // components: { TinymceEditor },
  data () {
    return {
      testVal: '',
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 行业速递表格数据
      newsList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 9,
        newsTitle: null,
        newsText: null,
        status: null,
        remark: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        newsTitle: [
          { required: true, message: '新闻标题不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getList()
    // this.getNewsInfo(this.$route.query.newsId)
  },
  methods: {
    /** 查询行业速递列表 */
    getList () {
      this.loading = false
      this.$get('/system/news/site/list', this.queryParams)
        .then(res => {
          const response = res.data
          this.newsList = response.rows
          this.total = response.total
          this.loading = false
        })
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
      this.queryParams.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.queryParams.pageNum = val
      this.getList()
    },
    reset () {
      this.form = {
        newsId: null,
        newsTitle: null,
        newsText: null,
        status: '0',
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      }
      this.resetForm('form')
    },
    skipToInfo (row) {
      this.$router.push({ path: `/newsInfo`, query: { newsId: row.newsId, _: Math.random() } })
    },
    getNewsInfo (newsId) {
      this.$get('/system/news/' + newsId)
        .then(response => {
          this.form = response.data
        })
    }
  }
}
</script>

<style scoped lang="less">
  @media screen {
    /*手机端*/
    @media (max-width: 600px){
      .app-container{
        background-color: #F6F7FB;
        .news-banner{
          /*background-image: url('../assets/news/news_banner.png');*/
          /*height: 50vh;*/
          /*background-repeat: no-repeat;*/
          /*background-size: 100% auto;*/
          /*background-position: top;*/
          img {
            width: 100%;
            display: block;
          }
        }

        .news-area{
          min-height: 600px;
          max-width: 900px;
          text-align: center;
          margin: auto;
          padding-top: 30px;
          .news-search{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            font-size: 18px;
            .base-line{
              border-bottom: 2px solid #ff9d00;
            }
            .search-input{
              width: 70%;
            }
          }
          .news-list{
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            .new-item{
              width: 250px;
              height: 250px;
              margin: 20px 0;
              font-size: 0.5rem;
              background-color: #ffffff;
              .new-item-img{
                height: 150px;
                width: 250px;
              }
              .new-item-title{
                text-align: left;
                font-weight: bold;
                padding-top: 10px;
                word-wrap: break-word;
                word-break: break-all;
                height: 60px;
                font-size: 14px;
              }
              .new-item-date{
                text-align: left;
                font-size: 0.3rem;
                padding-top: 10px;
              }
            }
          }
          .news-list::after{
            content: '';
            width: 250px;
            margin: 20px 0;
          }

        }
        .pagination{
          display: flex;
          justify-content: space-around;
        }
      }
    }
    /*电脑端*/
    @media (min-width: 601px){
      .app-container{
        background-color: #F6F7FB;
        .news-banner{
          /*background-image: url('../assets/news/news_banner.png');*/
          /*height: 50vh;*/
          /*background-repeat: no-repeat;*/
          /*background-size: 100% auto;*/
          /*background-position: top;*/
          img {
            width: 100%;
            display: block;
          }
        }

        .news-area{
          min-height: 600px;
          max-width: 900px;
          text-align: center;
          margin: auto;
          padding-top: 30px;
          .news-search{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .base-line{
              border-bottom: 2px solid #ff9d00;
            }
          }
          .news-list{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: center;
            .new-item{
              width: 250px;
              height: 250px;
              margin: 20px 0;
              font-size: 0.5rem;
              background-color: #ffffff;
              .new-item-img{
                height: 150px;
                width: 250px;
              }
              .new-item-title{
                text-align: left;
                font-weight: bold;
                padding-top: 10px;
                word-wrap: break-word;
                word-break: break-all;
                height: 60px;
                font-size: 14px;
              }
              .new-item-date{
                text-align: left;
                font-size: 0.3rem;
                padding-top: 10px;
              }
            }
          }
          .news-list::after{
            content: '';
            width: 250px;
            margin: 20px 0;
          }

        }
        .pagination{
          display: flex;
          justify-content: space-around;
        }
      }
    }
  }
  /*.new-banner{*/
    /*height: 300px;*/
    /*width: 100%;*/
    /*overflow: hidden;*/
    /*.new-banner-img{*/
      /*height: 100%;*/
      /*width: 100%;*/
    /*}*/
  /*}*/
</style>
